import { FilterInterface } from './filter.model';
import { SiteFilterInterface } from './site-filter.model';

export interface SiteFilterStateInterface {
  siteFilters?: SiteFilterInterface;
  managementFilters?: FilterInterface[];
}

export class SiteFilterState implements SiteFilterStateInterface {
  public siteFilters?: SiteFilterInterface;
  public managementFilters?: FilterInterface[];

  constructor({
    siteFilters = undefined,
    managementFilters = undefined,
    }: SiteFilterStateInterface) {
    this.siteFilters = siteFilters;
    this.managementFilters = managementFilters;
  }
}
